import clsx from "clsx";
import { PipeScheduleEditor } from "./PipeScheduleEditor";

interface PipeScheduleDrawerProps {
  open: boolean;
  onClose: () => void;
}

/**
 * Tools-section drawer hosting the pipe-schedule editor. Mirrors the
 * DiaryDrawer / PreprocessingDrawer pattern. Reachable from the
 * sidebar's Tools section when develop mode is on.
 */
export function PipeScheduleDrawer({ open, onClose }: PipeScheduleDrawerProps) {
  return (
    <>
      <div
        className={clsx(
          "fixed inset-0 bg-black/25 transition-opacity z-40",
          open ? "opacity-100" : "opacity-0 pointer-events-none",
        )}
        onClick={onClose}
      />
      <aside
        className={clsx(
          "fixed top-0 right-0 bottom-0 w-[820px] max-lg:w-full max-lg:max-w-none z-50 bg-surface1 border-l border-border1",
          "transform transition-transform duration-200",
          open ? "translate-x-0" : "translate-x-full",
        )}
      >
        <div className="flex items-center justify-between h-16 px-6 border-b border-border1">
          <div>
            <div className="text-[10.5px] uppercase tracking-[0.22em] text-dim">Tools</div>
            <h2 className="text-[15px] font-semibold text-text">Pipe schedule</h2>
          </div>
          <button onClick={onClose} className="text-muted hover:text-text text-lg">×</button>
        </div>

        <div className="p-5 overflow-y-auto h-[calc(100%-64px)]">
          {open && <PipeScheduleEditor />}
        </div>
      </aside>
    </>
  );
}
